<template>
  <div>
    <!--
        //
        //
        //
        -->
    <searchUser ref="searchUser" :selected="onSubmit" />

    <!-- Mobile's view -->
    <div v-if="isMobile()">
      Room<br />
      <roomSelect ref="roomSelect" />
      <div style="margin: 10px 0" />

      <!-- Booking's detail -->
      Type of Booking (Class, Major Skill, Rehearsal, Practice others)
      <a-input placeholder="สาเหตุการจอง เช่น ชื่อวิชา/เรียนเดี่ยว/เรียนกลุ่ม เป็นต้น" v-model="data.title" />
      <div style="margin: 10px 0" />
      Detail
      <a-textarea v-model="data.detail" placeholder="โปรดระบุรายละเอียด" :auto-size="{ minRows: 3, maxRows: 20 }" />
      <div style="margin: 10px 0" />
      <a-divider />

      <!-- Booking date -->
      <a-row type="flex" justify="space-between" align="top">
        <a-col :span="10">
          Date
          <a-date-picker v-model="data.date" />
        </a-col>
        <a-col :span="6">
          Start
          <a-select default-value="06:00" style="width: 100%" v-model="data.slotNumberStart"
            @change="onSelectStartChanged()">
            <a-select-option v-for="  t   in   times  " :key="t.i" :value="t.i">{{
      t.label
    }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          End
          <a-select default-value="07:00" style="width: 100%" v-model="data.slotNumberEnd"
            @change="onSelectEndChanged()">
            <a-select-option v-for="  t   in   times  " :key="t.i" :value="t.i">{{
      t.label
    }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </div>

    <!-- desktop's view -->
    <div v-else>
      Room<br />
      <roomSelect ref="roomSelect" />
      <div style="margin: 10px 0" />

      <!-- Booking's detail -->
      Type of Booking (Class, Major Skill, Rehearsal, Practice others)
      <a-input placeholder="สาเหตุการจอง เช่น ชื่อวิชา/เรียนเดี่ยว/เรียนกลุ่ม เป็นต้น" v-model="data.title" />
      <div style="margin: 10px 0" />
      Detail
      <a-textarea v-model="data.detail" placeholder="โปรดระบุรายละเอียด" :auto-size="{ minRows: 3, maxRows: 20 }" />
      <div style="margin: 10px 0" />
      <a-divider />

      <!-- Booking date -->
      <a-row type="flex" justify="space-between" align="top">
        <a-col :span="10">
          Date
          <a-date-picker v-model="data.date" />
        </a-col>
        <a-col :span="6">
          Start
          <a-select default-value="06:00" style="width: 100%" v-model="data.slotNumberStart"
            @change="onSelectStartChanged()">
            <a-select-option v-for="  t   in   times  " :key="t.i" :value="t.i">{{
      t.label
    }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          End
          <a-select default-value="07:00" style="width: 100%" v-model="data.slotNumberEnd"
            @change="onSelectEndChanged()">
            <a-select-option v-for="  t   in   times  " :key="t.i" :value="t.i">{{
      t.label
    }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </div>
    <a-divider />

    <!-- Attendee -->
    <table width="100%">
      <tbody>
        <tr>
          <td>Attendee</td>
          <td align="right">
            <a-button type="primary" shape="circle" icon="plus" @click="onSearch" />
          </td>
        </tr>
      </tbody>
    </table>
    <div style="margin-top: 10px">
      <a-descriptions size="small" :column="1">
        <a-descriptions-item label="">
          <a-tag :key="a" closable @close="removeAttendee(a)" v-for="  a   in  data.attendeesName ">{{ a }}</a-tag>
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import searchUser from "../../components/Search/SearchUser";
import roomSelect from "../../components/Inventories/RoomSelect";
import tools from "../../utils/tools";
import moment from "moment";

export default {
  props: {
    // date: String,
    // slotLabel: String,
    // slotNumber: String,
    // roomId: String,
    // roomName: String,
  },
  components: {
    searchUser,
    roomSelect
  },
  data() {
    return {
      isReadOnly: false,
      //
      times: [],
      //
      data: {
        bookingId: "",
        //
        date: "",
        //
        userId: localStorage.getItem("id"),
        // userEmail: localStorage.getItem("username"),
        userEmail: "",
        userCard: "",
        userRole: localStorage.getItem("role"),
        //
        roomId: "",
        roomName: "",
        //
        slotLabelStart: "",
        slotNumberStart: 0,
        slotLabelEnd: "",
        slotNumberEnd: 0,
        //
        title: "",
        detail: "",
        // phone: "",
        //
        attendees: [],
        //
        attendeesName: []
      }
    };
  },
  //
  //
  //
  mounted() {
    //
    for (let i = 24; i <= 84; i++) {
      this.times.push({
        i: i,
        label: this.cnv(i)
      });
    }
  },
  methods: {
    //
    //
    //
    isMobile() {
      return tools.isMobile();
    },
    //
    //
    //
    cnv(number) {
      const hours = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ];
      const mins = ["00", "15", "30", "45"];
      if (number => 0 && number <= 3) {
        return hours[Math.floor(number / 4)] + ":" + mins[number % 4];
      }
    },
    //
    //
    //
    setInfo(data, mode) {
      this.data = data;
      //
      this.$refs.roomSelect.value = data.roomId;
      this.$refs.roomSelect.text = data.roomName;
      this.$refs.roomSelect.isReadOnly = false;
      //
      if (mode === "edit") {
        this.isReadOnly = true;
        this.$refs.roomSelect.isReadOnly = true;
      }
      // console.log(JSON.stringify(data));
    },
    //
    //
    //
    getInfo() {
      this.data.roomId = this.$refs.roomSelect.value;
      this.data.roomName = this.$refs.roomSelect.text;
      // Convert date utc format to date string only
      this.data.date = moment(this.data.date).format("YYYY-MM-DD");
      //
      return this.data;
    },
    //
    //
    //
    onSelectStartChanged() {
      this.data.slotLabelStart = this.cnv(this.data.slotNumberStart);
    },
    //
    //
    //
    onSelectEndChanged() {
      this.data.slotLabelEnd = this.cnv(this.data.slotNumberEnd);
    },
    //
    //
    //
    onSearch() {
      this.$refs.searchUser.show();
    },
    //
    //
    //
    async onSubmit(data) {
      console.debug("data = ", data);

      // Check duplicate attendee or myself
      if (
        this.data.attendees.includes(data._id) ||
        data.id === localStorage.getItem("username")
      ) {
        return;
      }

      // Push data
      this.data.attendees.push(data._id);
      this.data.attendeesName.push(data.name);
    },
    //
    //
    //
    removeAttendee(email) {
      let id = this.data.attendees[this.data.attendeesName.indexOf(email)];
      this.data.attendees = this.data.attendees.filter(i => {
        return i !== id;
      });
      this.data.attendeesName = this.data.attendeesName.filter(i => {
        return i !== email;
      });
    }
  }
};
</script>

<style lang="scss">
.ant-calendar-picker {
  width: 100%;
}
</style>
